import React from 'react';
import { NxTension } from '@warehouse/title/feature-nx-tension';
import { NxTensionStoreProvider } from '@warehouse/quickbase';

function NxTensionTab() {
	return (
		<NxTensionStoreProvider>
			<NxTension />
		</NxTensionStoreProvider>
	);
}

export { NxTensionTab };
